import {useDebugValue} from 'react';

import {runHPPrePopulateCookieExperiment} from '../../../utils/experiments';

import {useValues} from './useValues';

const defaultGuestsValues = {
    adultsCount: 0,
    ageData: [],
    childrenCount: 0,
    bedroomsCount: 0,
    petIncluded: false
};

function useGuestsValues(props, searchCookies, systemOptions, abacusStore) {
    const {
        guestsValues: propsGuestsValues
    } = props;

    let {
        guestsValues: cookiesGuestsValues
    } = searchCookies;

    cookiesGuestsValues = runHPPrePopulateCookieExperiment({shouldLogExperiment: true}, abacusStore, systemOptions, searchCookies) ? {} : cookiesGuestsValues;

    const {
        initialValues: initialGuestsValues,
        currentValues: currentGuestsValues,
        latestValues: latestGuestsValues,
        setCurrentValues: setCurrentGuestsValues,
        setCurrentValuesDefault: setCurrentGuestsValuesDefault,
        setCurrentValuesInitial: setCurrentGuestsValuesInitial,
        setCurrentValuesLatest: setCurrentGuestsValuesLatest,
        setLatestValues: setLatestGuestsValues,
        setLatestValuesDefault: setLatestGuestsValuesDefault,
        setLatestValuesInitial: setLatestGuestsValuesInitial,
        setLatestValuesCurrent: setLatestGuestsValuesCurrent,
        setAllValues: setAllGuestsValues,
        setAllValuesDefault: setAllGuestsValuesDefault,
        setAllValuesInitial: setAllGuestsValuesInitial
    } = useValues(defaultGuestsValues, cookiesGuestsValues, propsGuestsValues);

    const result = {
        defaultGuestsValues,
        initialGuestsValues,
        currentGuestsValues,
        latestGuestsValues,
        setCurrentGuestsValues,
        setCurrentGuestsValuesDefault,
        setCurrentGuestsValuesInitial,
        setCurrentGuestsValuesLatest,
        setLatestGuestsValues,
        setLatestGuestsValuesDefault,
        setLatestGuestsValuesInitial,
        setLatestGuestsValuesCurrent,
        setAllGuestsValues,
        setAllGuestsValuesDefault,
        setAllGuestsValuesInitial
    };

    useDebugValue(result);

    return result;
}

export {useGuestsValues};
